import React from "react";
import { createRoot } from "react-dom/client";
import { Amplify } from "aws-amplify";
import "./index.css";
import App from "./App";
import awsconfig from "./aws-exports";
import { CookiesProvider } from "react-cookie";
import { Provider } from "react-redux";
import { persistor, store } from "../redux/store/store";
import * as Sentry from "@sentry/react";
import { PersistGate } from "redux-persist/integration/react";

/** Default pool for the app (member). `/measure/login` overrides via `configureAmplifyPool`. */
Amplify.configure(awsconfig);

let environment = "local";

if (window.location.hostname === "ignite.wemeasure.org") {
  environment = "production";
} else if (window.location.hostname === "dev.ignite.wemeasure.org") {
  environment = "staging";
}

Sentry.init({
  dsn: "https://66e21a83a8c8e411bcc47a086bfb3f9f@o4507776309788672.ingest.us.sentry.io/4507776312147968",
  environment,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.browserProfilingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    "localhost",
    /^https:\/\/dev\.ignite\.wemeasure\.org/,
    /^https:\/\/ignite\.wemeasure\.org/,
  ],
  // Set profilesSampleRate to 1.0 to profile every transaction.
  // Since profilesSampleRate is relative to tracesSampleRate,
  // the final profiling rate can be computed as tracesSampleRate * profilesSampleRate
  // For example, a tracesSampleRate of 0.5 and profilesSampleRate of 0.5 would
  // results in 25% of transactions being profiled (0.5*0.5=0.25)
  profilesSampleRate: 1.0,
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <CookiesProvider>
          <App />
        </CookiesProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);
